

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_e47ilr9bxb = () => {
                    
                        if (document.querySelector('.beae-q0lxbs7x:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-q0lxbs7x:not([data-beae-bind])'),
                                
                                id: 'beae-q0lxbs7x',
                                isLive: true
                            });
                            document.querySelector('.beae-q0lxbs7x:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-8kx6f4gn:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-8kx6f4gn:not([data-beae-bind])'),
                                
                                id: 'beae-8kx6f4gn',
                                isLive: true
                            });
                            document.querySelector('.beae-8kx6f4gn:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_e47ilr9bxb()
                } else {
                    window.beaePageJS.push(jsHandle_e47ilr9bxb)
                }
            